<!--====================================================
                  FOOTER
======================================================-->
<footer>
    <div id="footer-s1" class="footer-s1">
      <div class="footer">
        <div class="container">
          <div class="row">
            <!-- About Us -->
            <div class="col-md-4 col-sm-6">
              <div>
                <img src="assets/img/logo-w.png" alt="" class="img-fluid" />
              </div>
              <ul class="list-unstyled comp-desc-f">
                <li>
                  <p>
                    Mundo Financiera nacio para apoyarte a conseguir tus metas, prestamos un servicio con todas las garantías de calidad para darte la confianza de que somos tú mejor opción, siempre pensando en ser eficientes para que las ideas y necesidades de nuestros clientes sean atendidas con prontitud.
                  </p>
                </li>
              </ul>
              <br />
            </div>
            <!-- End About Us -->

            <!-- Recent News -->
            <div class="col-md-4 col-sm-6">

              <ul class="list-unstyled link-list">
                <li>
                  <a [routerLink]="['/quienessomos']">Quienes somos</a
                  ><i class="fa fa-angle-right"></i>
                </li>
                <li>
                  <a [routerLink]="['/contacto']">Contáctenos</a
                  ><i class="fa fa-angle-right"></i>
                </li>
              </ul>
            </div>
            <!-- End Recent list -->

            <!-- Recent Blog Entries -->
            <!--<div class="col-md-3 col-sm-6 ">
                <div class="heading-footer"><h2>Recent Post Entries</h2></div>
                <ul class="list-unstyled thumb-list">
                  <li>
                    <div class="overflow-h">
                      <a href="#">Praesent ut consectetur diam.</a>
                      <small>02 OCT, 2017</small>
                    </div>
                  </li>
                  <li>
                    <div class="overflow-h">
                      <a href="#">Maecenas pharetra tellus et fringilla.</a>
                      <small>02 OCT, 2017</small>
                    </div>
                  </li>
                </ul>
              </div>-->
            <!-- End Recent Blog Entries -->

            <!-- Latest Tweets -->
            <div class="col-md-4 col-sm-6">
              <div class="heading-footer"><h2>Ponerse en contacto</h2></div>
              <address class="address-details-f">
                Calle 13a #100- 35 Torre empresarial Oficina 514 Ciudad Jardin<br />
                Cali, Col <br />
                <br />
                Líneas directas: <br /> Operaciones: <i class="fa fa-whatsapp"></i> &nbsp;<a href="https://wa.me/3164034791?text=Operaciones">3164034791</a>
                <br /> Recaudo y Cartera: <i class="fa fa-whatsapp"></i> &nbsp;<a href="https://wa.me/3174409708?text=Recaudo y Cartera">3174409708</a><br />
                <br /> Teléfono Fijo: &nbsp;(602) 3928850<br />


                <br />
                Correo Administración:
                <a href="mailto:admin@mundofinanciera.com" class=""
                  >admin@mundofinanciera.com</a>
                <br />
                <br />
                Correo Servicio al cliente:

                <a href="mailto:servicioalcliente@mundofinanciera.com" class=""
                >servicioalcliente@mundofinanciera.com</a>
                <br />
                <br />
                Correo de operaciones:

                <a href="mailto:mf@mundofinanciera.com" class=""
                >mf@mundofinanciera.com</a>
                <br />
                <br />
                Correo Servicio al cliente:

                <a href="mailto:recaudoycartera@mundofinanciera.com" class=""
                >recaudoycartera@mundofinanciera.com</a>
              </address>
              <!--<ul class="list-inline social-icon-f top-data">
                  <li><a href="#" target="_empty"><i class="fa top-social fa-facebook"></i></a></li>
                  <li><a href="#" target="_empty"><i class="fa top-social fa-twitter"></i></a></li>
                  <li><a href="#" target="_empty"><i class="fa top-social fa-google-plus"></i></a></li>
                </ul>-->
            </div>
            <!-- End Latest Tweets -->
          </div>
        </div>
        <!--/container -->
      </div>
    </div>

    <div id="footer-bottom">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div id="footer-copyrights">
              <p>
                Copyrights &copy; 2021 Todos los derechos reservados Mundo
                Financiera. <a [routerLink]="['/terminos-condiciones']">Politica de privacidad y terminos de servicio</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a
      [routerLink]="['']"
      id="back-to-top"
      class="btn btn-sm btn-green btn-back-to-top smooth-scrolls hidden-sm hidden-xs"
      title="home"
      role="button"
      href="#"
    >
      <i class="fa fa-angle-up"></i>
    </a>
  </footer>
